// Lib
import { Capacitor } from '@capacitor/core';

// Utils
import { LifecyclePlugin } from '../../../capacitor_plugins/lifecycle';
import { CAPACITOR_LIFECYCLE_PLUGIN } from '../../../capacitor_plugins/pluginConstants';

/**
 * Tells the native app that the web app has rendered something the user can see, so the native
 * launch screen that covers the web view during boot can be removed.
 *
 * The native launch screen is normally hidden when the workspace or the logged-out splash finishes
 * loading. Any other terminal state the app can boot into (an error page, a "please update" prompt,
 * a loader that has given up) must also call this, otherwise it stays hidden behind a blank launch
 * screen the user can neither see nor recover from (WEB-16041, WEB-16798).
 *
 * No-op outside the Capacitor apps.
 */
export const hideNativeLaunchScreen = (): void => {
    if (!Capacitor.isPluginAvailable(CAPACITOR_LIFECYCLE_PLUGIN)) return;

    // The native side treats this purely as "the web has rendered, hide the launch screen".
    LifecyclePlugin.splashDidLoad();
};
